const COMPLAINT_TYPE = [{
	val: 1,
	name: '骚扰'
}, {
	val: 2,
	name: '诈骗'
}, {
	val: 3,
	name: '不良内容'
}, {
	val: 99,
	name: '其他'
}]

export {
	COMPLAINT_TYPE
}
